<template>
  <tk-button
    v-bind="$attrs"
    :disabled="disabled"
    class="tkLeftArrowButton"
    v-on="$listeners"
  >
    <slot />
    <tk-left-arrow class="tkLeftArrowButton_arrow"/>
  </tk-button>
</template>

<script>
import TkButton from '../../../atoms/TkButton/TkButton'
import TkLeftArrow from '../../../atoms/arrow/TkLeftArrow/TkLeftArrow'

export default {
  name: 'TkLeftArrowButton',
  components: {
    TkButton,
    TkLeftArrow,
  },
  props: {
    /**
     * Native button disabled attribute
     */
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
.tkLeftArrowButton {
  position: relative;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid;
  font-size: 100%;
  height: 100%;
  width: 100%;
  text-align: center;

  &.-red {
    background: #F9423A;
    border-color: #f9423a;
    color: #ffffff;
  }
  &.-gray {
    background: #63666A;
    border-color: #63666A;
    color: #ffffff;
  }
}

.tkLeftArrowButton_arrow {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
}
</style>
